export default __webpack_public_path__ + "static/media/KY.21f14be9.svg";